<template>
    <a-card
        :bordered="false" 
        class="header-solid h-full" 
    >
        <!-- style="background-color: #ebeced;" -->
        <template #title>
            <!-- <div style="display:flex; flex-direction: row;">   
                <a-avatar
                    :size="54"
                    shape="square"
                    src="/images/payment.png"
                />
            </div> -->
            <div class="mt-20">
                <h6 class="font-semibold mb-10">{{ $t('radio-btn-caption.debarred')}} : {{ data.debarred }}</h6>
                <h6 class="font-semibold mb-10" >{{ $t('form-label.date-of-debarred')}} : {{ data.dateOfDebarred }}</h6>
                <h6 class="font-semibold mb-10" >{{ $t('form-label.debarred-where')}} : {{ data.whereDebarred }}</h6>
                <h6 class="font-semibold mb-10" >{{ $t('form-label.debarred-long')}} : {{ data.howLongDebarred }}</h6>
            </div>
            
        </template>
    </a-card>
</template>

<script>
export default {
    name: "OthersInformation",
    props: {
        data: {
            type: Object,
            required: true
        }
    }
}
</script>

<style>

</style>